import { computed } from 'vue'
import { useUserStore } from '@teams/common/store/user'
import useAppDialog from '@/components/appDialog/useAppDialog'

// 拦截个人账号创建空间
export const useChangeAccountDialog = () => {
  const userStore = useUserStore()
  const appDialog = useAppDialog()
  const isCompanyAccount = computed(() => userStore.isCompanyAccount)
  const user = computed(() => {
    const currentAccount = userStore.currentAccount
    return {
      userAvatar: currentAccount?.avatar_url,
      nickname: currentAccount?.nickname
    }
  })
  const openChangeAccountDialog = () => {
    appDialog.show({
      name: 'BlockPersonalCreate',
      componentProps: {
        user: user
      }
    })
  }
  return {
    isCompanyAccount,
    openChangeAccountDialog
  }
}
